import { getTooltip } from '@/lib/tooltips';
import { useDisplayMode } from '@/lib/display-mode';

/**
 * Blendet im Standard- und im geführten Modus eine ausführliche
 * Inline-Erklärung zum Feld ein (Quelle: zentrales Tooltip-Inventory,
 * `lib/tooltips.ts`). Im Profi-Modus – oder wenn kein `helpKey` / kein
 * Eintrag existiert – rendert die Komponente nichts.
 */
export function FieldHelpInline({ helpKey }: { helpKey?: string }) {
  const { mode } = useDisplayMode();
  if (mode === 'profi' || !helpKey) return null;
  const entry = getTooltip(helpKey);
  if (!entry) return null;

  return (
    <div className="rounded-md border border-ink-200 bg-ink-50 px-2.5 py-1.5 text-[11px] leading-relaxed text-ink-600">
      <p>{entry.body}</p>
      {entry.legalRef ? (
        <p className="mt-1 text-[10px] uppercase tracking-wide text-ink-400">{entry.legalRef}</p>
      ) : null}
    </div>
  );
}
